import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Box, Typography } from '@mui/material';

import { BolPhotoAttachment } from '../types';

interface Props {
  attachment: BolPhotoAttachment;

}
export const PhotoDetails = ({ attachment }: Props) => {
  const { t } = useTranslation();
  const date = moment(attachment.createdAt).format('MMM D, YYYY');
  return (
    <Box p={2}>
      <Typography variant="overline">
        {t('dateAdded')}
      </Typography>
      <Typography variant="body1">
        {date}
      </Typography>
    </Box>
  );
};
